import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import JsonFormatter from './pages/JsonFormatter';
import XmlFormatter from './pages/XmlFormatter';
import Base64Tool from './pages/Base64Tool';
import UrlEncoder from './pages/UrlEncoder';
import CharacterCounter from './pages/CharacterCounter';
import ImageToBase64 from './pages/ImageToBase64';
import JsonToXml from './pages/JsonToXml';
import XmlToJson from './pages/XmlToJson';
import ContentDiff from './pages/ContentDiff';
import Md5Tool from './pages/Md5Tool';
import RegexTool from './pages/RegexTool';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tools/json-formatter" element={<JsonFormatter />} />
          <Route path="/tools/xml-formatter" element={<XmlFormatter />} />
          <Route path="/tools/base64" element={<Base64Tool />} />
          <Route path="/tools/url-encoder" element={<UrlEncoder />} />
          <Route path="/tools/character-counter" element={<CharacterCounter />} />
          <Route path="/tools/image-to-base64" element={<ImageToBase64 />} />
          <Route path="/tools/json-to-xml" element={<JsonToXml />} />
          <Route path="/tools/xml-to-json" element={<XmlToJson />} />
          <Route path="/tools/content-diff" element={<ContentDiff />} />
          <Route path="/tools/md5" element={<Md5Tool />} />
          <Route path="/tools/regex" element={<RegexTool />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
